import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-chips',
  templateUrl: './user-chips.component.html',
  styleUrls: ['./user-chips.component.scss']
})
export class UserChipsComponent {

  @Input() userEmails: string[];
  constructor() { }


}
